import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GatewayGetTransactionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchTransactionListContext } from '../../transaction.context';
import { TransactionListFilterSearchFormStep1Controller } from '../transaction-list-filter-search-form-step-1/transaction-list-filter-search-form-step-1.controller';

export interface TransactionListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GatewayGetTransactionsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GatewayGetTransactionsPaginatedModel>;
  onCancel: () => void;
}

export const TransactionListFilterSearchFormController = (
  props: TransactionListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchTransactionListContext();

  return (
    <HeadlessFormProvider<GatewayGetTransactionsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <TransactionListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
